import React from 'react';

import classes from './SelectOption.scss';

const selectOption = (props) => {

    return (
        <li {...props} className={`${classes.Option} u-fontSize13 u-textColorDark u-flex justify-content-between align-items-center u-cursorPointer pt-0 pb-0 pl-3 pr-3 u-transitionAll300Ease`}>{props.children}</li>
    );
}

export default selectOption;


// WEBPACK FOOTER //
// ./src/components/UI/SelectMenu/SelectOption/SelectOption.js